module.exports = __webpack_public_path__ + "img/RJC_LP_nachhaltigkeit@2x.4d63b9a.jpg";